// extracted by mini-css-extract-plugin
export default {"products":"Products_products__35Oc8","products_list":"Products_products_list__NWiCz"};